import { setupWorker } from "msw/browser";
import { handlers } from "./handlers/index";
import { installMockControls } from "./latency";

export async function enableMocking(): Promise<void> {
  if (typeof window === "undefined") return;
  const worker = setupWorker(...handlers);
  await worker.start({ onUnhandledRequest: "bypass", quiet: true });
  installMockControls();
}
